import { AsistenteServicesService } from './../../services/asistente-services.service';
import {
  Component,
  OnInit,
  TemplateRef,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';
import swal from 'sweetalert2';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-referra-list',
  templateUrl: './referra-list.component.html',
  styleUrls: ['./referra-list.component.css'],
})
export class ReferraListComponent implements OnInit {
  constructor(
    private AsistenteServicesService: AsistenteServicesService,
    private modalService: BsModalService,
    private _http: HttpClient,
    public _helper: HelpersService,
    public router: Router
  ) { }

  asistentes: any = [];
  @Output() reloadFormula = new EventEmitter();
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;

  config = {
    animated: true,
    class: 'modal-dialog-centered modal-sm',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  modalRef: BsModalRef;
  cc_type = '';
  first_name;
  last_name;
  cc;
  country_code = '';
  cell;
  especialidad = '';
  medic_id = ''; // ID del médico seleccionado
  specialties: any;
  medic_array: any; // Array de médicos
  codeUnique: string = '';
  showTooltip: boolean = false;

  configMetas = {
    animated: true,
    class: 'modal-xl modal-dialog-centered',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  urlGenerada: string = '';
  tiempo_expire;

  selectSpecialties: any = null;

  showLoading: boolean = true;
  page = 1;
  limit = 1;
  count = 0;

  ngOnInit() {
    this.showLoading = true;
    this.referall();
    this.specialty_medic();
    this.LoadMedics(); // Cargar lista de médicos
  }

  referall() {
    this.AsistenteServicesService.referralList(this.page)
      .toPromise()
      .then((data) => {
        console.log(data);
        this.limit = Math.ceil(data['count']);
        this.count = data['count'];
        this.asistentes = data['results'];
        this.showLoading = false;
      })
      .catch((error) => console.log(error));
  }

  pageChanged(p) {
    this.page = p.page;
    this.referall();
  }

  async AbrirModalCrearAsistente(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.configMetas);
  }

  crearAsist() {
    // Validación básica
    if (!this.medic_id) {
      this._helper.modalError('Debe seleccionar un médico');
      return;
    }

    if (!this.cc_type || !this.first_name || !this.last_name || !this.cc || !this.cell) {
      this._helper.modalError('Todos los campos son obligatorios');
      return;
    }

    if (!this.selectSpecialties || !this.selectSpecialties['specialty_id__id']) {
      this._helper.modalError('Debe seleccionar una especialidad');
      return;
    }

    this.AsistenteServicesService.crearAsistente(
      this.medic_id, // Ahora sí enviamos el médico seleccionado
      this.cc_type,
      this.first_name,
      this.last_name,
      this.cc,
      this.country_code,
      this.cell,
      this.selectSpecialties['specialty_id__id']
    )
      .toPromise()
      .then((data) => {
        this._helper.modalSuccess(data['message']);
        this.limpiarFormulario();
        this.referall(); // Recargar la lista
        this.modalRef.hide();
      })
      .catch((error) => {
        this._helper.modalError(error.error.error || 'Error al crear el referido');
      });
  }

  limpiarFormulario() {
    this.medic_id = '';
    this.cc_type = '';
    this.first_name = '';
    this.last_name = '';
    this.cc = '';
    this.cell = '';
    this.especialidad = '';
    this.selectSpecialties = null;
  }

  specialty_medic() {
    this.AsistenteServicesService.especialidad_medico().subscribe((data) => {
      this.specialties = data;
    });
  }

  LoadMedics() {
    this.AsistenteServicesService.LoadMedics().subscribe(
      (data) => {
        this.medic_array = data;
        console.log('Médicos cargados:', this.medic_array);
      },
      (error) => {
        console.error('Error al cargar médicos:', error);
        this._helper.modalError('Error al cargar la lista de médicos');
      }
    );
  }

  onSelect2(event: TypeaheadMatch): void {
    this.selectSpecialties = event.item;
  }

  generateQr(): void {
    const apiUrl = environment.api_generate_url;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {};

    this._http.post(apiUrl, body, { headers }).subscribe(
      (response: any) => {
        this.urlGenerada = response.url;
        this.codeUnique = response.session;
        this._helper.modalSuccess('Código generado con éxito');
        this.mostrarModalQR(this.modalTemplate);
      },
      error => {
        this._helper.modalAlert('Error al generar código');
      }
    );
  }

  async mostrarModalQR(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  copyToClipboard(code: string) {
    const el = document.createElement('textarea');
    el.value = code;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    this.showTooltip = true;
  }

  hideTooltip() {
    setTimeout(() => {
      this.showTooltip = false;
    }, 2000);
  }
}
